module.exports = __webpack_public_path__ + "img/绿色石化产业专利动态图片.0c0df2ad.png";